/**
 * @file language-flags.ts
 * @brief Country code resolution for language flag images (flagcdn.com).
 *
 * @details
 * Ported from FRONTEND/src/shared/data/languages.ts::getLanguageCountryCode
 * so WEBPANEL language pickers match mobile `VZLanguagePicker` visuals.
 *
 * @author DES
 * @date 19-06-2026
 */

export type LanguageFlagInput = { code: string; locale?: string };

export function getLanguageCountryCode(l: LanguageFlagInput): string {
  if (l.locale && l.locale.includes("-")) {
    const parts = l.locale.split("-");
    const countryPart = parts[parts.length - 1].toLowerCase();
    if (countryPart.length === 2) return countryPart;
  }

  const mapping: Record<string, string> = {
    en: "us",
    ur: "pk",
    ar: "sa",
    ps: "af",
    hi: "in",
    bn: "bd",
    fa: "ir",
    ja: "jp",
    ko: "kr",
    zh: "cn",
    es: "es",
    fr: "fr",
    de: "de",
    it: "it",
    ru: "ru",
    tr: "tr",
    pt: "pt",
    vi: "vn",
    th: "th",
    id: "id",
    te: "in",
    ta: "in",
    kn: "in",
    ml: "in",
    gu: "in",
    mr: "in",
    sq: "al",
    am: "et",
    hy: "am",
    az: "az",
    be: "by",
    bs: "ba",
    bg: "bg",
    ca: "es",
    hr: "hr",
    cs: "cz",
    da: "dk",
    nl: "nl",
    et: "ee",
    fi: "fi",
    ka: "ge",
    el: "gr",
    hu: "hu",
    is: "is",
    kk: "kz",
    km: "kh",
    lo: "la",
    lv: "lv",
    lt: "lt",
    mk: "mk",
    mn: "mn",
    no: "no",
    pl: "pl",
    ro: "ro",
    sr: "rs",
    sk: "sk",
    sl: "si",
    sv: "se",
    uk: "ua",
    uz: "uz",
    he: "il",
    af: "za",
    sw: "tz",
    so: "so",
    sn: "zw",
    zu: "za",
    mt: "mt",
    ms: "my",
    my: "mm",
    ne: "np",
    si: "lk",
    ha: "ng",
    yo: "ng",
    ig: "ng",
    tk: "tm",
    tg: "tj",
    ky: "kg",
    tt: "ru",
    ba: "ru",
    haw: "us",
    yue: "hk",
    bo: "cn",
    br: "fr",
    cy: "gb",
    eu: "es",
    gl: "es",
    ht: "ht",
    lb: "lu",
    oc: "fr",
    yi: "il",
    jw: "id",
    as: "in",
    sd: "pk",
    pa: "in",
    ln: "cd",
    mi: "nz",
    tl: "ph",
    su: "id",
    sa: "in",
    nn: "no",
    la: "va",
    mg: "mg",
  };

  return mapping[l.code.toLowerCase()] || l.code.toLowerCase();
}

export function languageFlagUrl(l: LanguageFlagInput, width = 80): string {
  const cc = getLanguageCountryCode(l);
  return `https://flagcdn.com/w${width}/${cc}.png`;
}
